// Stage 14F: descriptive side-by-side view over two current Decision Pictures. No scores, no winner.
export const COMPARE_SECTIONS = [
  { key: "supports", shared: "Both choices line up with…", side: "This fits here" },
  { key: "tradeoffs", shared: "Both choices ask you to accept…", side: "You're accepting" },
  { key: "conflicts", shared: "Worth another look for both choices…", side: "Worth another look for this option…" },
  { key: "unresolved", shared: "You haven't decided this yet for either choice…", side: "You haven't decided this yet…" },
];

export const THEME_LABELS = {
  "course.exact": "The subject you've confirmed",
  "course.family": "The subject area you've confirmed",
  course: "Your course pattern",
  "city.major": "A major-city environment",
  "city.size": "City size",
  climate: "Climate",
  cost: "Living costs above your saved budget",
  country: "Your country focus",
  reputation: "Reputation",
};

const sameText = (x, y) => x.label === y.label && (x.detail || "") === (y.detail || "");

// Shared = same semantic code AND same consequence state (bucket). Different states never pair.
export function compareOptions(left, right) {
  const out = {};
  for (const { key } of COMPARE_SECTIONS) {
    const L = left?.[key] || [];
    const R = right?.[key] || [];
    const used = new Set();
    const shared = [];
    const leftOnly = [];
    for (const x of L) {
      const j = x.semantic ? R.findIndex((y, i) => !used.has(i) && y.semantic === x.semantic) : -1;
      if (j < 0) {
        leftOnly.push(x);
        continue;
      }
      used.add(j);
      const y = R[j];
      shared.push(sameText(x, y) ? { semantic: x.semantic, same: true, item: x } : { semantic: x.semantic, same: false, left: x, right: y });
    }
    out[key] = { shared, left: leftOnly, right: R.filter((_, i) => !used.has(i)) };
  }
  return out;
}

export function optionName(o) {
  if (!o) return "";
  return [o.degree_title, o.university_name].filter(Boolean).join(" · ");
}
